export const actualsViewPermissions = ["read-only", "as-runs-admin", "bil-admin", "admin"];
export const bilViewPermissions = ["read-only", "as-runs-admin", "bil-admin", "admin"];
export const reportsViewPermissions = ["read-only", "as-runs-admin", "bil-admin", "admin"];
export const feedbackViewPermissions = ["read-only", "as-runs-admin", "bil-admin", "admin"];
export const adminViewPermissions = ["admin"];
export const actualsEditPermissions = ["as-runs-admin", "admin"];
export const bilEditPermissions = ["bil-admin", "admin"];
export const actualsDeletePermissions = ["as-runs-admin", "admin"];
export const bilDeletePermissions = ["bil-admin", "admin"];

export const allUserRoles = [
  { value: "admin", label: "Admin" },
  { value: "as-runs-admin", label: "As Runs Admin" },
  { value: "bil-admin", label: "BIL Admin" },
  { value: "read-only", label: "Read Only" },
  { value: "no-access", label: "No Access" },
  { value: "new-user", label: "New User" },
];
